import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const MapMarkerLocationIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.8 8.466H3V9h4.8v-.533ZM5.4 4.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z" />
            <path d="m3.4 4.733 2 2.988 1.989-2.979v-.008A2.4 2.4 0 1 0 3 3.4c-.001.475.14.94.405 1.333H3.4ZM3.533 3.4a1.867 1.867 0 1 1 3.419 1.036L5.399 6.761 3.848 4.437A1.862 1.862 0 0 1 3.533 3.4Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const MapMarkerLocationIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.8 8.466H3V9h4.8v-.533ZM5.4 4.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z" />
            <path d="m3.4 4.733 2 2.988 1.989-2.979v-.008A2.4 2.4 0 1 0 3 3.4c-.001.475.14.94.405 1.333H3.4ZM3.533 3.4a1.867 1.867 0 1 1 3.419 1.036L5.399 6.761 3.848 4.437A1.862 1.862 0 0 1 3.533 3.4Z" />
        </SvgIcon>
    );
};
